import React, { useState, useRef, useEffect } from "react";
import { usePopper } from "react-popper";

const Header = ({
  loggedIn,
  openModal,
  mapLoaded,
  modalIsOpen,
  setModal,
  setShowMenu,
}) => {
  const headerRef = useRef(null);
  const popperRef = useRef(null);
  const [arrowRef, setArrowRef] = useState(null);
  const [disablePopper, setDisablePopper] = useState(false);
  const [showPopper, setShowPopper] = useState(false);
  const { styles, attributes } = usePopper(
    headerRef.current,
    popperRef.current,
    {
      modifiers: [
        {
          name: "arrow",
          options: {
            element: arrowRef,
          },
        },
      ],
    }
  );

  useEffect(() => {
    if (mapLoaded && !loggedIn && !disablePopper) {
      setShowPopper(true);
      const timer = setTimeout(() => {
        setShowPopper(false);
        setDisablePopper(true);
      }, 30000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [disablePopper, loggedIn, mapLoaded, setDisablePopper, setShowPopper]);

  const handleClick = () => {
    setShowPopper(false);
    setDisablePopper(true);
    setShowMenu(false);
    setModal("about");
    openModal();
  };

  return (
    <>
      <button
        className="header"
        onClick={handleClick}
        id={modalIsOpen ? "hide-header" : null}
      >
        <h1 aria-describedby="tooltip" ref={headerRef}>
          kittymapper
        </h1>
      </button>
      {!loggedIn && !disablePopper && showPopper ? (
        <div
          id="tooltip"
          role="tooltip"
          ref={popperRef}
          style={styles.popper}
          {...attributes.popper}
        >
          <div
            id="arrow"
            data-popper-arrow
            ref={setArrowRef}
            style={styles.arrow}
          />
          <p id="tooltip-text">Click here to get started</p>
        </div>
      ) : null}
    </>
  );
};

export default Header;
